// ── Claves de API: de plataforma vs. del cliente (2026-08-18) ────────────────
//
// Agujero real, verificado en producción: el store de secretos era GLOBAL y
// `PUT /api/settings/secrets/:key` solo exigía ser owner de la propia cuenta.
// Una cuenta cliente ACTIVA podía sobrescribir la clave de Anthropic o la
// secret key de Stripe de la plataforma y dejar sin servicio a todas las demás
// cuentas — incluida la operadora. Con la de Stripe, además, se pueden emitir
// cobros.
//
// Dos clases, con reglas distintas:
//
//  PLATAFORMA  — infraestructura de EvoHub. Solo is_platform_admin las ve o las
//                escribe. Una cuenta cliente no debe ni saber que existen: la
//                sección ni se le muestra.
//
//  PROPIA      — el cliente puede traer la suya ("bring your own"). Se guarda
//                POR CUENTA, aislada, y si está cargada se usa ESA en lugar de
//                la de plataforma. Como el consumo lo paga él directamente al
//                proveedor, ese servicio no se le factura.
export const PLATFORM_ONLY_SECRET_KEYS = [
    // Slots históricos, sin modo. Siguen aceptándose como respaldo para no
    // romper una instalación que ya los tiene cargados.
    'stripe-secret-key', // cobros — con esto se puede facturar en nombre de EvoHub
    'stripe-webhook-secret',
    // Slots por modo (2026-08-31). Las dos llaves pueden estar cargadas a la vez
    // y el interruptor de Configuración elige cuál se usa — ver
    // server/services/stripeMode.ts. Tenerlas separadas es lo que permite probar
    // el flujo completo y después pasar a real sin volver a pegar credenciales.
    'stripe-secret-key-test',
    'stripe-secret-key-live',
    'stripe-webhook-secret-test',
    'stripe-webhook-secret-live',
    'platform-email-api-key', // Resend: los avisos salen del dominio de EvoHub
];
/**
 * Claves con las dos variantes: la de plataforma (fallback que EvoHub presta y
 * cobra) y la propia del cliente. El slot del cliente vive namespaced por
 * cuenta — mismo patrón que `imap-accounts:{accountId}`, que ya existía.
 */
export const BYO_SECRET_KEYS = [
    'anthropic-api-key',
    'openai-api-key',
    'groq-api-key',
    'google-tts-api-key',
    'elevenlabs-api-key',
];
export const PLATFORM_ONLY_SET = new Set(PLATFORM_ONLY_SECRET_KEYS);
export const BYO_SET = new Set(BYO_SECRET_KEYS);
/** Slot de la clave PROPIA de una cuenta. Nunca colisiona con el de plataforma
 *  (que no lleva sufijo) — por eso el cliente no puede pisarla ni por accidente. */
export function accountSecretKey(key, accountId) {
    return `${key}:${accountId}`;
}
/** Qué servicio de api_usage corresponde a cada clave — para no cobrar el
 *  consumo de un servicio que el cliente está pagando con su propia clave. */
export const SECRET_KEY_TO_SERVICE = {
    'anthropic-api-key': 'claude',
    'openai-api-key': 'openai',
    'groq-api-key': 'groq',
    'google-tts-api-key': 'google_tts',
    'elevenlabs-api-key': 'elevenlabs',
};
// ── Claves de `settings` que decide la PLATAFORMA, no el cliente (2026-08-18) ─
// Auditoría pedida por Eduardo tras el tercer hallazgo del mismo tipo: "revisá
// si hay otras rutas de Ajustes donde un owner cliente pueda escribir algo que
// solo debería decidir yo".
//
// Son los topes de gasto. Un cliente que se sube su propio límite mensual gasta
// la cuenta de Anthropic/Google de EvoHub, no la suya — el cobro por consumo
// todavía no está activo en ninguna cuenta (usage_billing_since NULL), así que
// hoy ese gasto no vuelve por ningún lado. `web_form.token` va acá porque es
// una credencial de la cuenta, no una preferencia.
//
// Lista NEGRA y no lista blanca, a propósito: una lista blanca se desactualiza
// en el próximo setting nuevo y el modo de falla es "la preferencia del cliente
// deja de guardarse en silencio", que es exactamente la clase de bug que
// venimos persiguiendo. Acá el modo de falla es al revés — un setting nuevo
// nace escribible, igual que hoy — y lo que hay que acordarse de agregar es
// solo la categoría enumerable de "tope de gasto".
export const PLATFORM_ONLY_SETTING_KEYS = [
    'api_usage.monthly_limit_usd',
    'daily-cap-usd',
    'web_form.token',
];
export function isPlatformOnlySettingKey(key) {
    return PLATFORM_ONLY_SETTING_KEYS.includes(key);
}
//# sourceMappingURL=api-keys.js.map